import { render, staticRenderFns } from "./FrkLogo.vue?vue&type=template&id=7f6c927a&scoped=true&"
import script from "./FrkLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkLogo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FrkLogo.vue?vue&type=style&index=0&id=7f6c927a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c927a",
  null
  
)

export default component.exports